import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BranchListComponent } from './branch-list/branch-list.component';
import { BranchCreateComponent } from './branch-create/branch-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: BranchListComponent,
        data: {
          title: "Branch List",
          breadcrumb: "Branch List"
        }
      },
      {
        path: 'create',
        component: BranchCreateComponent,
        data: {
          title: "Create Branch",
          breadcrumb: "Create Branch"
        }
      },
      {
        path: 'edit/:id',
        component: BranchCreateComponent,
        data: {
          title: "Edit Branch",
          breadcrumb: "Edit Branch"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class BranchRoutingModule { }
